import { Component, Input } from '@angular/core';

/**
 * Simple grid layout.
 * @example
 * <ess-grid>
 *                <ess-row>
 *                      <ess-col> Left </ess-col>
 *                      <ess-col> Right </ess-col>
 *                </ess-row>
 *                <ess-row [expandable]="true">
 *                      <ess-col> Spanning entire row </ess-col>
 *                      <div expanded> This can be shown/hidden </div>
 *                </ess-row>
 * </ess-grid>
 * 
 */
@Component({
    selector: 'ess-grid',
    templateUrl: './grid.html',
    styleUrls: ['./grid.scss']
})
export class SmartGrid {

    // @Input('cols')
    // cols: number = 0;

    // @Input('spacing')
    // spacing: number = 0;

    // @Input('border')
    // border: string = 'initial';

}